import '../../../../SignalViewerContainer/components/NewTemplateModal/NewTemplateModal.scss';

export { default } from './NewTemplateModal';
